// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.guardiianwallet",
    name: "GUARDIIAN Wallet",
    homepage: "https://guardiianwallet.io/",
    image_id: "4f095c1d-8a31-4af8-ab58-57e82a398e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/pk/app/guardiian-wallet/id6478384338",
        android: "https://play.google.com/store/apps/details?id=com.gardianwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "guardiianwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map